import { __assign, __awaiter, __generator } from "tslib";
import { last } from 'lodash';
import { mmUid } from 'mm-ts-utils';
import { dataLayerPush } from '../../client-externals/utils';
import { BaseChatMessage, ChatMessageType, } from '../../client/src/_library/domain-base/BaseChatMessage';
import { AGENT_USER_ID, COMMAND_BLOCK, DOMAIN_TYPE_CHAT_MESSAGE, DOMAIN_TYPE_CHAT_MESSAGE_COMMAND, GOODBOT_USER_ID, NOTIFICATION_ID__THREAD_CHANGE, NOTIFICATION_ID__THREAD_CREATED, NOTIFICATION_ID__THREAD_IS_TYPING, } from '../../client/src/consts';
import { apiNormalizeJsonApiResponse } from '../../client/src/modules/_core/utils/api-helpers';
import { matchAll } from '../../client/src/modules/_core/utils/app-utils';
import { ChatMessage } from '../../client/src/modules/chat/ChatMessage';
import { clientNotification } from '../../client/src/modules/domain/domain-helpers';
var BUTTON_PATTERN = /\[button=([^\]]+)]([^[]+)\[\/button]/g;
var BLOCK_COMMAND_PATTERN = /!block({[^}]*})/;
var LINK_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
var HTTP_REGEX = /(https?:\/\/)/;
var MARKDOWN_LINK_REGEX = /(\[.+])\((https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})\)/;
var BACKEND_LINK_REGEX = /\[url=(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\]\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\]\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\]\s]{2,}|www\.[a-zA-Z0-9]+\.[^\]\s]{2,})](.+)(\[\/url])/g;
var AdastraApiAdapter = /** @class */ (function () {
    function AdastraApiAdapter(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.timestamp = 0;
        this.readThread = function (threadId) { return __awaiter(_this, void 0, void 0, function () {
            var activities, lastActivity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchActivities(threadId)];
                    case 1:
                        activities = _a.sent();
                        lastActivity = last(activities);
                        return [2 /*return*/, apiNormalizeJsonApiResponse({
                                data: activities,
                                included: [
                                    clientNotification(NOTIFICATION_ID__THREAD_CHANGE, {
                                        thread_id: threadId,
                                        created: new Date(),
                                    }),
                                    // https://jira.sazka.cz/browse/CHU-112
                                    clientNotification(NOTIFICATION_ID__THREAD_IS_TYPING, lastActivity.attributes.type === ChatMessageType.TRANSIENT_IS_TYPING
                                        ? {
                                            thread_id: threadId,
                                            user_id: [lastActivity.attributes.user_id],
                                        }
                                        : null),
                                ],
                            })];
                }
            });
        }); };
        this.fetchActivities = function (threadId) { return __awaiter(_this, void 0, void 0, function () {
            var _a, sessionId, sessionHash, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = threadId.split('|'), sessionId = _a[0], sessionHash = _a[1];
                        return [4 /*yield*/, this.httpClient.get("/sessions/".concat(sessionId, "/hash/").concat(sessionHash, "/activity/").concat(this.timestamp, "?timestampFormat=ms"), {
                                'X-Interaction-Id': mmUid(),
                                'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.Activities.map(this.toChatMessage.bind(this, threadId))];
                }
            });
        }); };
        this.createThread = function (id, api_token, options) { return __awaiter(_this, void 0, void 0, function () {
            var _a, campaignCode, creativeCode, Username, PlayerID, playerID, SessionKey, _b, ProactiveChat, _c, Referrer, _d, Location, flow, isComplaint, complaintTicketNumber, response, activities, threadId;
            var _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _a = options === null || options === void 0 ? void 0 : options.initialData, campaignCode = _a.campaignCode, creativeCode = _a.creativeCode, Username = _a.Username, PlayerID = _a.PlayerID, playerID = _a.playerID, SessionKey = _a.SessionKey, _b = _a.ProactiveChat, ProactiveChat = _b === void 0 ? false : _b, _c = _a.Referrer, Referrer = _c === void 0 ? '' : _c, _d = _a.Location, Location = _d === void 0 ? '' : _d, flow = _a.flow, isComplaint = _a.isComplaint, complaintTicketNumber = _a.complaintTicketNumber;
                        return [4 /*yield*/, this.httpClient.post("/sessions/", {
                                Session: {
                                    Referrer: Referrer,
                                    Location: Location,
                                    CampaignCode: campaignCode !== null && campaignCode !== void 0 ? campaignCode : null,
                                    CreativeCode: creativeCode !== null && creativeCode !== void 0 ? creativeCode : null,
                                    Email: Username !== null && Username !== void 0 ? Username : '',
                                    PlayerId: (_e = PlayerID !== null && PlayerID !== void 0 ? PlayerID : playerID) !== null && _e !== void 0 ? _e : '',
                                    TimestampFormat: 'ms',
                                    flow: flow,
                                    isComplaint: isComplaint !== null && isComplaint !== void 0 ? isComplaint : false,
                                    complaintTicketNumber: complaintTicketNumber !== null && complaintTicketNumber !== void 0 ? complaintTicketNumber : null,
                                },
                                SessionKey: SessionKey,
                            }, {
                                'Player-Id': (_f = PlayerID !== null && PlayerID !== void 0 ? PlayerID : playerID) !== null && _f !== void 0 ? _f : '',
                                'X-Interaction-Id': mmUid(),
                                'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
                            })];
                    case 1:
                        response = _g.sent();
                        activities = response.Activities;
                        threadId = "".concat(response.Session.Id, "|").concat(response.Session.ChatHash);
                        dataLayerPush({
                            event: 'action.open.chat',
                            action: {
                                open: {
                                    chatNumber: threadId,
                                    campaignCode: campaignCode,
                                    creativeCode: creativeCode,
                                    proactive: ProactiveChat,
                                },
                            },
                        });
                        return [2 /*return*/, apiNormalizeJsonApiResponse({
                                data: activities.map(this.toChatMessage.bind(this, threadId)),
                                included: [
                                    clientNotification(NOTIFICATION_ID__THREAD_CREATED, {
                                        thread_id: threadId,
                                    }),
                                ],
                            })];
                }
            });
        }); };
        this.saveMessage = function (messageData, threadData, token, options) { return __awaiter(_this, void 0, void 0, function () {
            var threadId, _a, sessionId, sessionHash, activities, userMsgCount, isFirstUserMsg, _i, activities_1, msg, message, _b, campaignCode, creativeCode, _c, ProactiveChat, includedEntities, deletedActivity;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        threadId = messageData.thread_id;
                        _a = threadId.split('|'), sessionId = _a[0], sessionHash = _a[1];
                        return [4 /*yield*/, this.httpClient.post("/sessions/".concat(sessionId, "/hash/").concat(sessionHash, "/activity/"), {
                                Activity: {
                                    Id: messageData.id,
                                    Type: messageData.type === ChatMessageType.HIDDEN
                                        ? 'SilentMessage'
                                        : 'Message',
                                    Message: messageData.body,
                                },
                            }, {
                                'X-Interaction-Id': messageData.id,
                                'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
                            })];
                    case 1:
                        _e.sent();
                        return [4 /*yield*/, this.fetchActivities(threadId)];
                    case 2:
                        activities = _e.sent();
                        userMsgCount = 0;
                        isFirstUserMsg = true;
                        for (_i = 0, activities_1 = activities; _i < activities_1.length; _i++) {
                            msg = activities_1[_i];
                            message = new ChatMessage(__assign(__assign({}, msg), msg.attributes));
                            if (message.authorType === BaseChatMessage.AUTHOR_TYPE_USER) {
                                userMsgCount++;
                            }
                            if (userMsgCount === 2) {
                                isFirstUserMsg = false;
                                break;
                            }
                        }
                        if (isFirstUserMsg) {
                            _b = options === null || options === void 0 ? void 0 : options.initialData, campaignCode = _b.campaignCode, creativeCode = _b.creativeCode, _c = _b.ProactiveChat, ProactiveChat = _c === void 0 ? false : _c;
                            dataLayerPush({
                                event: 'action.firstUserMessage.chat',
                                action: {
                                    firstUserMessage: {
                                        chatNumber: threadId,
                                        campaignCode: campaignCode,
                                        creativeCode: creativeCode,
                                        proactive: ProactiveChat,
                                    },
                                },
                            });
                        }
                        includedEntities = [
                            clientNotification(NOTIFICATION_ID__THREAD_CHANGE, {
                                thread_id: threadId,
                                created: new Date(),
                            }),
                        ];
                        _d = AdastraApiAdapter.deleteDuplicateMessage(messageData, activities), activities = _d[0], deletedActivity = _d[1];
                        if (deletedActivity) {
                            messageData.id = deletedActivity.id;
                            includedEntities.push(new ChatMessage(__assign(__assign({}, deletedActivity), deletedActivity.attributes)).toJSONApi());
                        }
                        return [2 /*return*/, apiNormalizeJsonApiResponse({
                                data: activities,
                                included: includedEntities,
                            })];
                }
            });
        }); };
        this.sendMail = function (threadId, email) {
            var _a = threadId.split('|'), sessionId = _a[0], sessionHash = _a[1];
            return _this.httpClient.post("/sessions/".concat(sessionId, "/hash/").concat(sessionHash, "/activity/email"), {
                Email: email,
            }, {
                'X-Interaction-Id': mmUid(),
                'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
            });
        };
        this.sendStaffino = function (threadId, data) {
            var _a = threadId.split('|'), sessionId = _a[0], sessionHash = _a[1];
            return _this.httpClient.post("/staffino", __assign({ sessionId: sessionId, hash: sessionHash }, data), {
                'X-Interaction-Id': mmUid(),
                'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
            });
        };
        this.sendNotification = function (threadId, _a) {
            var playerId = _a.playerId, action = _a.action, sessionKey = _a.sessionKey;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, sessionId, sessionHash;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!threadId) {
                                return [2 /*return*/];
                            }
                            _b = threadId.split('|'), sessionId = _b[0], sessionHash = _b[1];
                            return [4 /*yield*/, this.httpClient.post("/sessions/".concat(sessionId, "/hash/").concat(sessionHash, "/activity/"), {
                                    Activity: {
                                        Type: 'LoginMessage',
                                        Message: "U\u017Eivatel s playerID: ".concat(playerId, " se ").concat(action === 'login' ? 'přihlásil' : 'odhlásil'),
                                    },
                                    SessionKey: sessionKey,
                                }, {
                                    'Player-Id': playerId,
                                    'Activity-Action': action,
                                    'X-Interaction-Id': mmUid(),
                                    'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
                                })];
                        case 1:
                            _c.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.httpClient = httpClient;
    }
    AdastraApiAdapter.prototype.toChatMessage = function (threadId, activity) {
        var user_id = this.getUserId(activity);
        var is_bot = user_id === GOODBOT_USER_ID;
        var additionalProps = { meta: {} };
        var body;
        var type = DOMAIN_TYPE_CHAT_MESSAGE;
        if (activity.Type === ChatMessageType.WIDGET) {
            body = JSON.parse(activity.Message);
            additionalProps.body = body.name;
            additionalProps.meta = { data: { widget: body.widget } };
        }
        else {
            body = activity.Message.replace(BUTTON_PATTERN, '').trim();
            body = AdastraApiAdapter.replaceBackendLinksWithMarkdown(body);
        }
        var options = matchAll(activity.Message, BUTTON_PATTERN).map(function (o) { return o[2]; });
        var blockMatch = BLOCK_COMMAND_PATTERN.exec(activity.Message);
        if (blockMatch) {
            type = DOMAIN_TYPE_CHAT_MESSAGE_COMMAND,
                additionalProps.meta.commandName = COMMAND_BLOCK;
            var commandProps = {};
            try {
                commandProps = JSON.parse(blockMatch[1]);
            }
            catch (e) {
                // no action
            }
            additionalProps.meta.commandProps = commandProps;
        }
        additionalProps.meta.options = options;
        additionalProps.meta.isChatInputHidden = activity.IsChatInputHidden;
        additionalProps.meta.variantId = activity.variantId;
        return {
            id: activity.Id,
            type: type,
            attributes: __assign({ id: activity.Id, user_id: user_id, thread_id: threadId, is_bot: is_bot, type: activity.Type === 'Typing'
                    ? ChatMessageType.TRANSIENT_IS_TYPING
                    : activity.Type, body: body, 
                // Change back to new Date() if message ordering is broken
                created: new Date(Number(activity.TimeStamp)), timestamp: options.length
                    ? Number(activity.TimeStamp) + 1
                    : Number(activity.TimeStamp) }, additionalProps),
        };
    };
    // noinspection JSMethodCanBeStatic: it's broken for TypeScript
    AdastraApiAdapter.prototype.getUserId = function (activity) {
        switch (activity.UserId) {
            case ActivityUserType.CHATBOT:
                return GOODBOT_USER_ID;
            case ActivityUserType.AGENT:
                return AGENT_USER_ID;
            default:
                return undefined;
        }
    };
    AdastraApiAdapter.replaceLinksWithMarkdown = function (body) {
        if (!MARKDOWN_LINK_REGEX.test(body)) {
            if (LINK_REGEX.test(body)) {
                var url = body.match(LINK_REGEX)[0];
                if (HTTP_REGEX.test(url))
                    return body.replace(LINK_REGEX, "[".concat(url, "](").concat(url, ")"));
                else
                    return body.replace(LINK_REGEX, "[".concat(url, "](https://").concat(url, ")"));
            }
        }
        return body;
    };
    /** https://jira.sazka.cz/browse/CHU-432 */
    AdastraApiAdapter.replaceBackendLinksWithMarkdown = function (body) {
        return body.replace(BACKEND_LINK_REGEX, function (_, url, label) {
            label = AdastraApiAdapter.replaceBackendLinksWithMarkdown(label);
            if (HTTP_REGEX.test(url)) {
                return "[".concat(label, "](").concat(url, ")");
            }
            else {
                return "[".concat(label, "](https://").concat(url, ")");
            }
        });
    };
    AdastraApiAdapter.deleteDuplicateMessage = function (messageData, activities) {
        var msgBody = JSON.stringify(messageData.body);
        for (var i = activities.length - 1; i > 0; i--) {
            var activity = activities[i];
            var activityBody = JSON.stringify(activity.attributes.body);
            if (activityBody === msgBody) {
                return [activities.slice(i + 1), activity];
            }
        }
        return [activities, undefined];
    };
    AdastraApiAdapter.prototype.updateThread = function (threadId, data) {
        var _a = threadId.split('|'), sessionId = _a[0], sessionHash = _a[1];
        return this.httpClient.put("/sessions/".concat(sessionId, "/hash/").concat(sessionHash), data, {
            'X-Interaction-Id': mmUid(),
            'Ocp-Apim-Subscription-Key': process.env.ADASTRA_SUBCRIPTION_KEY,
        });
    };
    return AdastraApiAdapter;
}());
export default AdastraApiAdapter;
var SessionStatus;
(function (SessionStatus) {
    SessionStatus[SessionStatus["CHATBOT"] = -1] = "CHATBOT";
    SessionStatus[SessionStatus["WAITING_FOR_AGENT"] = 0] = "WAITING_FOR_AGENT";
    SessionStatus[SessionStatus["ACTIVE_AGENT"] = 1] = "ACTIVE_AGENT";
    SessionStatus[SessionStatus["INACTIVE_AGENT"] = 2] = "INACTIVE_AGENT";
})(SessionStatus || (SessionStatus = {}));
var ActivityUserType;
(function (ActivityUserType) {
    ActivityUserType[ActivityUserType["END_USER"] = 0] = "END_USER";
    ActivityUserType[ActivityUserType["AGENT"] = 1] = "AGENT";
    ActivityUserType[ActivityUserType["CHATBOT"] = 2] = "CHATBOT";
    /** Unused for now, see https://jira.sazka.cz/browse/CHU-61 */
    ActivityUserType[ActivityUserType["MESSAGE_IS_DISCLAIMER"] = 3] = "MESSAGE_IS_DISCLAIMER";
})(ActivityUserType || (ActivityUserType = {}));
